//Grades
export const GET_GRADES = 'user/Assessment/GetGrades';

//Branches
export const GET_BRANCHES = 'DropDown/GetBranchDropDown';

//Assessment
export const GET_ASSESSMENT_TEMPLATE = 'user/Assessment/GetAssessmentTemplate';
export const ADD_STUDENT_ASSESSMENT = 'user/Assessment/AddStudentAssessment';
export const DOWNLOAD_ASSESSMENT_REPORT = 'user/Assessment/DownloadAssessmentReport';
// [EMAIL DISABLED] Uncomment to re-enable sending report to parent email
// export const EMAIL_ASSESSMENT_REPORT = 'user/Assessment/EmailAssessmentReport';

export const GET_ASSESSMENT_DETAILS = "user/Assessment/GetAssessmentTypeById"
